import campaignConfig from '../../../../campaign-config/campaign.json';
import pointsIcon from '../../../../assets/images/pts.png';

export const globalColors = campaignConfig.global?.colors || {};
export const globalImages = campaignConfig.global?.images || {};

const localTasksAssets = {
	'src/assets/images/pts.png': pointsIcon,
};

export const tutorDetailsTasksConfig = campaignConfig.tutor_details?.tasks || {};

export const resolveTutorDetailsTasksAsset = (asset) =>
	localTasksAssets[asset] || asset;
